import moment from 'moment'
import { IdsTipoDeEvento, IdsTipoDeSolicitacao } from '@/typescript/modulos/governanca/solicitacoes/dominio/solicitacoes.enum'

export const ACAO_CONSULTAR_SOLICITACOES = 'consultar_solicitacoes'
export const CAMPOS_DA_ENTRADA = ['solicitacoes_inicio', 'solicitacoes_fim', 'solicitacoes_tipo', 'solicitacoes_status', 'solicitacoes_referencia', 'solicitacoes_local_id']
const TIPOS: Record<string, string> = {
  todos: IdsTipoDeEvento.Todos, correcao_de_ponto: IdsTipoDeEvento.CorrecaoDePonto,
  dispensa: IdsTipoDeEvento.Dispensa, suspensao: IdsTipoDeEvento.Suspensao,
  conversao_de_apontamento: IdsTipoDeEvento.ConversaoBH, alteracao_de_escala: IdsTipoDeEvento.AlteracaoEscala,
  ferias: IdsTipoDeEvento.Ferias, horas_extras: IdsTipoDeEvento.HorasExtra, sobreaviso: IdsTipoDeEvento.Sobreaviso
}
const STATUS: Record<string, string> = {
  todos: 'all', pendentes: IdsTipoDeSolicitacao.Pendente, aprovadas: IdsTipoDeSolicitacao.Aprovado,
  reprovadas: IdsTipoDeSolicitacao.Reprovado, com_erros: IdsTipoDeSolicitacao.Problema,
  canceladas: IdsTipoDeSolicitacao.Cancelado, vencidas_de_resposta: IdsTipoDeSolicitacao.VencidaDeResposta,
  pendentes_de_justificativa: IdsTipoDeSolicitacao.PendenteDeJustificativa,
  vencidas_de_justificativa: IdsTipoDeSolicitacao.VencidaDeJustificativa
}

export function periodoPadraoDeSolicitacoes () {
  return { startDate: moment().startOf('month').toDate(), endDate: moment().endOf('month').toDate() }
}

export function filtrosDaConversa (query: Record<string, unknown>) {
  function texto (chave: string): string | undefined {
    const valor = query[chave]
    if (valor === undefined) return undefined
    if (typeof valor !== 'string' || !valor.trim()) throw new Error('filtro_invalido')
    return valor
  }
  function data (chave: string) {
    const valor = texto(chave)
    if (valor === undefined) return undefined
    const dia = moment(valor, 'YYYY-MM-DD', true)
    if (!/^\d{4}-\d{2}-\d{2}$/.test(valor) || valor.startsWith('0000-') || !dia.isValid()) throw new Error('filtro_invalido')
    return dia.toDate()
  }
  function opcao (chave: string, mapa: Record<string, string>) {
    const valor = texto(chave)
    if (valor === undefined) return undefined
    if (!Object.prototype.hasOwnProperty.call(mapa, valor)) throw new Error('filtro_invalido')
    return mapa[valor]
  }
  const localId = texto('solicitacoes_local_id')
  if (localId !== undefined && !/^[a-f0-9]{24}$/.test(localId)) throw new Error('filtro_invalido')
  const inicio = data('solicitacoes_inicio')
  const fim = data('solicitacoes_fim')
  if (inicio && fim && inicio > fim) throw new Error('filtro_invalido')
  return {
    inicio, fim, localId,
    tipoId: opcao('solicitacoes_tipo', TIPOS), statusId: opcao('solicitacoes_status', STATUS),
    referenciaId: opcao('solicitacoes_referencia', { evento: 'dataDaSolicitacao', criacao: 'dataDaAuditoriaDaSolicitacao' })
  }
}

export function locaisDaEntrada<T extends { id: string, active?: boolean }> (locais: T[], localId?: string): T[] {
  const autorizados = locais.filter(local => local.active === true)
  if (!localId) return autorizados
  const encontrados = autorizados.filter(local => local.id === localId)
  if (encontrados.length !== 1) throw new Error('local_indisponivel')
  return encontrados
}
